import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import Attachments from "MODULES/shared/components/Attachments";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import { ATTACHMENT_TYPES } from "MODULES/Shipping/constants";
import { Col } from "react-bootstrap";
import LineItemsTable from "./LineItemsTable/LineItemsTable";

export default function Body({ shipment }) {
  return (
    <Col md={9}>
      <h2 style={{ marginTop: 26 }}>Parts</h2>
      <LineItemsTable />
      <Attachments
        resource={Map(shipment)}
        resourceType={resourceTypes.shipment}
        resourceKey="shipment"
        multiple
        attachmentTypes={ATTACHMENT_TYPES}
      />
    </Col>
  );
}

Body.propTypes = { shipment: T.shape({}).isRequired };



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Body/Body.jsx